import { api, type ApiEnvelope } from './api';

export interface ServerCartResponse {
  cart: unknown;
  items: unknown[];
  subtotal: number;
  itemCount: number;
}

export const cartService = {
  async get() {
    const { data } = await api.get<ApiEnvelope<ServerCartResponse>>('/cart');
    return data.data;
  },
  async addItem(payload: { productId: string; variantId?: string; quantity: number }) {
    const { data } = await api.post<ApiEnvelope<ServerCartResponse>>('/cart/items', payload);
    return data.data;
  },
  async updateItem(itemId: string, quantity: number) {
    const { data } = await api.patch<ApiEnvelope<ServerCartResponse>>(`/cart/items/${itemId}`, { quantity });
    return data.data;
  },
  async removeItem(itemId: string) {
    const { data } = await api.delete<ApiEnvelope<ServerCartResponse>>(`/cart/items/${itemId}`);
    return data.data;
  },
  async applyCoupon(code: string) {
    const { data } = await api.post<ApiEnvelope<ServerCartResponse>>('/cart/coupon', { code });
    return data.data;
  },
  async removeCoupon() {
    const { data } = await api.delete<ApiEnvelope<ServerCartResponse>>('/cart/coupon');
    return data.data;
  },
};
